import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import isEmailValid from '../../../../../utils/isEmailValid';
import { EmailsObjectType } from '../../types';

export default function useVtItensRelationsRequestEmails() {
  const [addVtItensRelationsRequestEmailModalShow, setAddVtItensRelationsRequestEmailModalShow] = useState(false);
  const [removeVtItensRelationsRequestEmailModalShow, setRemoveVtItensRelationsRequestEmailModalShow] = useState(false);
  const [vtItensRelationsRequestEmails, setVtItensRelationsRequestEmails] = useState<EmailsObjectType[]>([]);
  const [vtItensRelationsRequestEmailToAdd, setVtItensRelationsRequestEmailToAdd] = useState('');
  const [vtItensRelationsRequestEmailToRemove, setVtItensRelationsRequestEmailToRemove] = useState('');
  const [originalVtItensRelationsRequestEmails, setOriginalVtItensRelationsRequestEmails] = useState<EmailsObjectType[]>([]);
  const [vtItensRelationsRequestEmailOwnerNameToAdd, setVtItensRelationsRequestEmailOwnerNameToAdd] = useState('');

  const hasOriginalVtItensRelationsRequestEmailsChanged = useMemo((() => JSON.stringify(originalVtItensRelationsRequestEmails) !== JSON.stringify(vtItensRelationsRequestEmails)), [originalVtItensRelationsRequestEmails, vtItensRelationsRequestEmails]);
  const hasVtItensRelationsRequestEmailsToBeRendered = useMemo((() => vtItensRelationsRequestEmails.length > 0), [vtItensRelationsRequestEmails]);

  function handleVtItensRelationsRequestEmailToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setVtItensRelationsRequestEmailToAdd(event.target.value);
  }

  function handleVtItensRelationsRequestEmailOwnerNameToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setVtItensRelationsRequestEmailOwnerNameToAdd(event.target.value);
  }

  const addVtItensRelationsRequestEmail = useCallback(() => {
    const onlyEmails = vtItensRelationsRequestEmails.map((emailObj) => emailObj.email);
    const doesEmailAlreadyExists = onlyEmails.includes(vtItensRelationsRequestEmailToAdd);
    if (doesEmailAlreadyExists) {
      toast.warn('Este e-mail já foi adicionado!');
      return;
    }
    if (!isEmailValid(vtItensRelationsRequestEmailToAdd)) {
      toast.warn('E-mail inválido!');
      return;
    }
    setVtItensRelationsRequestEmails((prevState) => [...prevState, { email: vtItensRelationsRequestEmailToAdd, emailOwnerName: vtItensRelationsRequestEmailOwnerNameToAdd }]);
    setVtItensRelationsRequestEmailToAdd('');
    toast.success('E-mail adicionado. Não se esqueça de salvar as alterações para confirmar');
  }, [vtItensRelationsRequestEmailOwnerNameToAdd, vtItensRelationsRequestEmailToAdd, vtItensRelationsRequestEmails]);

  const removeVtItensRelationsRequestEmail = useCallback(() => {
    const filteredEmails = vtItensRelationsRequestEmails.filter((email) => email.email !== vtItensRelationsRequestEmailToRemove);
    setVtItensRelationsRequestEmails(filteredEmails);
    setRemoveVtItensRelationsRequestEmailModalShow(false);
    toast.success('E-mail removido. Não esqueça de salvar as configurações para aplicar as mudanças!');
    setVtItensRelationsRequestEmailToRemove('');
    setVtItensRelationsRequestEmailOwnerNameToAdd('');
  }, [vtItensRelationsRequestEmailToRemove, vtItensRelationsRequestEmails]);

  const resetVtItensRelationsRequestEmails = useCallback(() => {
    setVtItensRelationsRequestEmails(originalVtItensRelationsRequestEmails);
    toast.info('Suas alterações foram desfeitas');
  }, [originalVtItensRelationsRequestEmails]);

  return {
    vtItensRelationsRequestEmailOwnerNameToAdd,
    handleVtItensRelationsRequestEmailOwnerNameToAddChange,
    addVtItensRelationsRequestEmail,
    removeVtItensRelationsRequestEmailModalShow,
    resetVtItensRelationsRequestEmails,
    hasOriginalVtItensRelationsRequestEmailsChanged,
    vtItensRelationsRequestEmails,
    vtItensRelationsRequestEmailToAdd,
    handleVtItensRelationsRequestEmailToAddChange,
    vtItensRelationsRequestEmailToRemove,
    setVtItensRelationsRequestEmailToRemove,
    setRemoveVtItensRelationsRequestEmailModalShow,
    removeVtItensRelationsRequestEmail,
    addVtItensRelationsRequestEmailModalShow,
    setAddVtItensRelationsRequestEmailModalShow,
    hasVtItensRelationsRequestEmailsToBeRendered,
    setOriginalVtItensRelationsRequestEmails,
    setVtItensRelationsRequestEmails,
  };
}
